import { useEffect } from 'react'
import { useEsri } from '../hooks'

const esriReqs = ['esri/widgets/Compass']

const CompassWidget = ({ map, view, position }) => {
  const [ready, { Compass }] = useEsri(esriReqs)

  useEffect(() => {
    if (ready && map && view) {
      const compass = new Compass({
        view
      })
      view.ui.add(compass, position || 'top-right')
    }
  }, [ready, Compass, map, view, position])

  return null
}

export default CompassWidget
